(function (window, $) {
  var Cls = {};
  var $title = null;
  var $cat0_obj1 = null;
  var $cat0_obj2 = null;

  var $circle_0 = null;
  var $cat1_obj1 = null;
  var $cat1_obj2 = null;

  var $circle_1 = null;
  var $cat2_obj1 = null;
  var $cat2_obj2 = null;

  var $circle_2 = null;
  var $earth = null;

  var $cat3_obj3 = null;
  var $cat3_obj4 = null;
  var $cat3_obj5 = null;

  var $bt_bottom = null;
  var $pager = null;
  var $main = null;

  Cls.init = function () {
    $title = $("#seg6 .title1");
    $cat0_obj1 = $("#seg6 .cat0_obj1");
    $cat0_obj2 = $("#seg6 .cat0_obj2");

    $circle_0 = $("#seg6 .cat0_obj4");

    $cat1_obj1 = $("#seg6 .cat1_obj1");
    $cat1_obj2 = $("#seg6 .cat1_obj2");

    $circle_1 = $("#seg6 .cat1_obj4");

    $cat2_obj1 = $("#seg6 .cat2_obj1");
    $cat2_obj2 = $("#seg6 .cat2_obj2");

    $circle_2 = $("#seg6 .cat2_obj4");

    $earth = $("#seg6 .cat3 .obj1");

    $cat3_obj3 = $("#seg6 .cat3 .obj3");
    $cat3_obj4 = $("#seg6 .cat3 .obj4");
    $cat3_obj5 = $("#seg6 .cat3 .obj5");

    $bt_bottom = $("#seg6 .bt_bottom");

    $pager = $(".brand-Nav");

    $main = $("#main");
  };
  Cls.fixedAreaAnime = function () {};
  Cls.initialize = function () {
    $pager.hide();
    $title.stop(true, true).css({ opacity: "0" });

    $circle_0.stop(true, true).css({ top: "166px", left: "382px" });
    $circle_1.stop(true, true).css({ top: "303px", left: "286px" });
    $circle_2.stop(true, true).css({ top: "303px", left: "476px" });

    $earth.stop(true, true).css({ opacity: "0", top: "150px" });

    $cat3_obj3.stop(true, true).css({ opacity: "0" });
    $cat3_obj4.stop(true, true).css({ opacity: "0" });
    $cat3_obj5
      .stop(true, true)
      .css({ opacity: "0", display: "none" })
      .removeClass("clickable");
    $bt_bottom.css({ opacity: 0, display: "none" });

    $main.animate({ backgroundPosition: "50% 100%" }, 500, "easeOutExpo");
  };

  Cls.isAnimated = false;

  Cls.cat0 = function () {
    $pager.hide();
    Cls.isAnimated = true;
    Cls.initialize();
    $circle_0.css({ opacity: 0 });
    $circle_1.css({ opacity: 0 });
    $circle_2.css({ opacity: 0 });

    Anime.vertical($bt_bottom, "-=25px", 4000, 1000, "easeInOutQuart");
    $bt_bottom.css({ display: "block" });

    $title.delay(1500).animate({ opacity: "1" }, 2000, "easeOutQuart");

    setTimeout(function () {
      Anime.vertical($circle_0, "-=300px", 0, 2500, "easeInOutQuart");
    }, 100);
    setTimeout(function () {
      Anime.vertical($circle_1, "+=300px", 0, 2500, "easeInOutQuart");
      Anime.side($circle_1, "-=300px", 0, 2500, "easeInOutQuart");
    }, 400);
    setTimeout(function () {
      Anime.vertical($circle_2, "+=300px", 0, 2500, "easeInOutQuart");
      Anime.side($circle_2, "+=300px", 0, 2500, "easeInOutQuart");
    }, 600);

    Anime.vertical($cat0_obj1, "-=50px", 2400, 1000, "easeOutQuart");
    Anime.vertical($cat0_obj2, "-=50px", 2600, 1000, "easeOutQuart");

    Anime.vertical($cat1_obj1, "-=50px", 2600, 1000, "easeOutQuart");
    Anime.vertical($cat1_obj2, "-=50px", 2800, 1000, "easeOutQuart");

    Anime.vertical($cat2_obj1, "-=50px", 3000, 1000, "easeOutQuart");

    Anime.vertical(
      $cat2_obj2,
      "-=50px",
      3100,
      1000,
      "easeOutQuart",
      function () {
        Cls.isAnimated = false;
      }
    );
  };

  Cls.cat1 = function () {
    Cls.toEarth();
    $pager.hide();
  };

  Cls.toEarth = function () {
    Cls.isAnimated = true;

    $bt_bottom.fadeOut(1000);
    $("#seg6 .cat3").css({ opacity: 1 });

    $cat0_obj1.animate({ opacity: 0 }, 1500);
    $cat0_obj2.animate({ opacity: 0 }, 1500);

    $cat1_obj1.animate({ opacity: 0 }, 1500);
    $cat1_obj2.animate({ opacity: 0 }, 1500);

    $cat2_obj1.animate({ opacity: 0 }, 1500);
    $cat2_obj2.animate({ opacity: 0 }, 1500);

    $circle_0
      .delay(100)
      .animate({ top: "142px", left: "368px" }, 1000, "easeOutQuart")
      .delay(100)
      .animate({ opacity: "0" }, 600);
    $circle_1
      .delay(200)
      .animate({ top: "142px", left: "368px" }, 1000, "easeOutQuart")
      .delay(0)
      .animate({ opacity: "0" }, 200, "easeOutExpo");
    $circle_2
      .delay(300)
      .animate({ top: "142px", left: "368px" }, 1000, "easeOutQuart")
      .delay(0)
      .animate({ opacity: "0" }, 300, "easeOutExpo");

    Anime.fadeHalfSizeZoomIn($earth, 2300, "easeOutQuad", 0, up);

    function up() {
      $earth.delay(0).animate({ top: "37px" }, 2000, "easeInOutQuart");
      Cls.isAnimated = false;
    }

    $main
      .delay(0)
      .animate({ backgroundPosition: "50% 92%" }, 7000, "easeOutExpo");

    $title.animate({ opacity: "0" }, 1000, "easeOutQuart");

    Anime.fadeHalfSizeZoomIn($cat3_obj3, 2000, "easeOutQuad", 2900);
    $cat3_obj4.delay(4000).animate({ opacity: "1" }, 1000, "easeOutQuart");

    $cat3_obj5
      .css({ opacity: "0", display: "block" })
      .delay(5000)
      .animate({ opacity: "1" }, 1000, "easeOutQuart", function () {
        $(this).addClass("clickable");
      });
    //View Pager
    $pager.delay(6000).fadeIn(1000);
  };

  Cls.cat2 = function () {
    Cls.isAnimated = true;
    var H =
      $(".brand-Footer").outerHeight(true) + $(".brand-Nav").outerHeight() + 80;
    $(".ayn-Wrapper").css({ overflow: "hidden" });
    $(".brand-Wrapper").animate({ marginTop: -1 * H + "px" }, 500, function () {
      Cls.isAnimated = false;
    });
    $pager.css({ position: "relative", "z-index": 98 });
    $("#relatedLinkFoot").append($pager);
  };

  Cls.cat2reset = function () {
    Cls.isAnimated = true;

    $(".brand-Wrapper").animate({ marginTop: 0 }, 500, function () {
      Cls.isAnimated = false;
    });
    setTimeout(function () {
      $pager.css({ position: "absolute", "z-index": 100 });
      $("#relatedLink").append($pager);
    }, 300);
  };

  window.Seg6 = Cls;
})(window, $brand);
